import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const WeeklySessionWarningModal = ({
  isOpen = false,
  message = '',
  onConfirm = () => {},
  onCancel = () => {},
  loading = false,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onCancel}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog justify-content-center'
      backdrop={true}
      style={{ zIndex: 1060 }}>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          Schedule Another Session?
        </h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='s7 text-start'>{message}</div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-end gap-3 flex-row'>
        <Button
          variant='secondary-light'
          className='px-4 text-uppercase secondary-popup-button'
          size='sm'
          onClick={onCancel}
          disabled={loading}>
          Cancel
        </Button>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          onClick={onConfirm}
          disabled={loading}>
          {loading ? 'Scheduling...' : 'Yes'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default WeeklySessionWarningModal
